export const tableHeader = (t) => [
  {
    id: 'name',
    type: 'text',
    value: t('user:groups.table.name'),
  },
  {
    id: 'active',
    type: 'boolean',
    value: t('user:groups.table.active'),
  },
  {
    id: 'action',
    type: 'actions',
    value: '',
  },
]
